function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-681.000000, -230.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(681.000000, 230.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.990271,49.8928561 L28.249315,29.9250682 C29.052118,28.5867447 28.0887162,26.8734993 26.5360697,26.8734993 L20.3799724,26.8734993 L20.3799724,18.8435578 C20.3799724,8.4581668 11.9217673,-3.82378166e-05 1.53637635,-3.82378166e-05 C0.198052771,-3.82378166e-05 -0.497971086,1.60604565 0.411993355,2.56944744 L2.66037697,4.9783343 C6.24708417,8.88614356 8.22761188,13.9716776 8.22761188,19.2716301 L8.22761188,26.8198707 L2.01845963,26.8198707 C0.46619546,26.8198707 -0.497588708,28.5331161 0.305214252,29.8714397 L12.5642583,49.8392275 C13.3674436,51.1775511 15.2409054,51.1775511 15.990749,49.8930473 L15.990271,49.8928561 Z",
  fill: "#888"
}))));

var SvgBentArrow = function SvgBentArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "51px",
    viewBox: "0 0 29 51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBentArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bent-arrow.3f688b4e.svg";
export { ForwardRef as ReactComponent };